import { type Component } from 'vue';
import SiteHeader from '@components/layout/site-header/SiteHeader.vue';
import MrModal from '@components/base/mr-modal/MrModal.vue';
import MrButton from '@components/base/mr-button/MrButton.vue';
import MrIcon from '@components/base/mr-icon/MrIcon.vue';
import MrInput from '@components/base/mr-input/MrInput.vue';
import MrCheckbox from '@components/base/mr-checkbox/MrCheckbox.vue';
import Loading from '@components/base/mr-loading/MrLoading.vue';
import Loading2 from '@components/base/mr-fade-loading/MrFadeLoading.vue';
import MrDivider from '@components/base/MrDivider.vue';
import SiteFooter from '@components/layout/site-footer/SiteFooter.vue';
import FooterLogos from '@components/layout/site-footer/FooterLogos.vue';
import ContentAlert from '@components/ui/index&view&widget/ContentAlert.vue';
import MrDropdown from '@components/base/mr-dropdown/MrDropdown.vue';
import MrFix from '@components/base/MrFix.vue';
import MrSelect from '@components/base/mr-select/MrSelect.vue';
import ChangeSearch from '@components/ui/hotel&view/ChangeSearch.vue';
import SearchForm from '@components/ui/index&view&widget/SearchForm.vue';

// should remove most of these components
export default defineNuxtPlugin(({ vueApp }) => {
    vueApp.component('SiteHeader', SiteHeader);
    vueApp.component('MrModal', MrModal);
    vueApp.component('MrButton', MrButton);
    vueApp.component('MrIcon', MrIcon);
    vueApp.component('MrInput', MrInput);
    vueApp.component('MrCheckbox', MrCheckbox);
    vueApp.component('MrLoading', Loading);
    vueApp.component('MrFadeLoading', Loading2);
    vueApp.component('MrDivider', MrDivider);
    vueApp.component('SiteFooter', SiteFooter);
    vueApp.component('FooterLogos', FooterLogos);
    vueApp.component('ContentAlert', ContentAlert);
    vueApp.component('MrDropdown', MrDropdown);
    vueApp.component('MrSelect', MrSelect as Component);
    vueApp.component('ChangeSearch', ChangeSearch);
    vueApp.component('SearchForm', SearchForm);
    vueApp.component('MrFix', MrFix);
});
